<template>
  <v-row class="no-gutters">
    <v-col>
      <p v-if="!hideOuterLabel" class="mb-0 font-weight-medium">{{ $i18n.useSmsInput.VERIFICATION_CODE }}</p>
      <v-text-field
        class="sms-class"
        solo
        hide-details
        :value="displayValue"
        :disabled="disabled"
        maxlength="6"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        @input="onInput"
      />
    </v-col>
  </v-row>
</template>
<script lang="ts">
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

export const SMS_CODE_LENGTH: number = 6;

export function normalizeOtpDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, SMS_CODE_LENGTH);
}

@Component
export default class SmsInput extends Vue {
  @Prop({required: true})
  readonly value!: string | null;

  @Prop({default: false, type: Boolean})
  readonly disabled!: boolean;

  /** Hide the default verification label (e.g. TOTP modal has its own copy). */
  @Prop({default: false, type: Boolean})
  readonly hideOuterLabel!: boolean;

  prevNormalized = '';

  get displayValue(): string {
    return normalizeOtpDigits(this.value ?? '');
  }

  mounted(): void {
    this.prevNormalized = this.displayValue;
    this.$nextTick(() => {
      const el = this.$el.querySelector('input');
      if (el) {
        el.addEventListener('paste', this.onPasteEvent as EventListener);
      }
    });
  }

  beforeDestroy(): void {
    const el = this.$el.querySelector('input');
    if (el) {
      el.removeEventListener('paste', this.onPasteEvent as EventListener);
    }
  }

  @Watch('value')
  onValueChange(): void {
    this.prevNormalized = this.displayValue;
  }

  onInput(val: string | unknown): void {
    const raw = typeof val === 'string' ? val : (val as { target?: { value?: string } })?.target?.value ?? '';
    const n = normalizeOtpDigits(raw);
    const prevBefore = this.prevNormalized;
    this.prevNormalized = n;
    this.$emit('input', n);
    if (n.length === SMS_CODE_LENGTH && normalizeOtpDigits(prevBefore).length < SMS_CODE_LENGTH) {
      this.$emit('finish', n);
    }
  }

  onPasteEvent(e: ClipboardEvent): void {
    e.preventDefault();
    const text = e.clipboardData?.getData('text') ?? '';
    this.onInput(text);
  }
}
</script>
<style scoped lang="scss">
.sms-class {
  ::v-deep input {
    font-weight: 500;
    font-size: 24px;
    max-height: 56px;
  }
}
</style>
